import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';

var EyeSolidIcon = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    return (jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", "data-ui-icon": true }, props, { children: [title ? jsx("title", { children: title }) : null, jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.622 11.4L22 12l-.378.6c-.165.261-4.094 6.4-9.622 6.4s-9.458-6.139-9.622-6.4L2 12l.378-.6C2.542 11.14 6.472 5 12 5s9.457 6.139 9.622 6.4zm-7.173.6c0 1.289-1.096 2.333-2.449 2.333-1.353 0-2.45-1.044-2.45-2.333 0-1.289 1.097-2.333 2.45-2.333 1.353 0 2.45 1.044 2.45 2.333z", fill: "currentColor" })] })));
};

export { EyeSolidIcon };
//# sourceMappingURL=EyeSolidIcon.js.map
